import $ from 'jquery';
import 'slick-carousel';

document.querySelectorAll('.news__container').forEach((news) => {
	$(news).slick({
		dots: true,
		fade: false,
		arrows: false,
		rows: 0,
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2.25,
				}
			},
			{
				breakpoint: 575,
				settings: {
					slidesToShow: 1.25,
				}
			}
		]
	});
})


